"use strict";
"use es6";
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectUnsubscribedError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var ObjectUnsubscribedError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(ObjectUnsubscribedError, _Error);

  function ObjectUnsubscribedError() {
    var _this;

    (0, _classCallCheck2.default)(this, ObjectUnsubscribedError);

    var err = _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ObjectUnsubscribedError).call(this, 'object unsubscribed'));

    _this.name = err.name = 'ObjectUnsubscribedError';
    _this.stack = err.stack;
    _this.message = err.message;
    return _this;
  }

  return ObjectUnsubscribedError;
}((0, _wrapNativeSuper2.default)(Error));

exports.ObjectUnsubscribedError = ObjectUnsubscribedError;